<template>

  <div class="popup confirm show">
      <div class="popup-wrap">
          <div class="popup-title">
              <h2 hidden></h2>
              <h4 class="f-bold f-center mb-14">{{store.state.customConfirm.title}}</h4>
          </div>

          <div class="popup-content mb-30">
              <p class="f-center body-md">{{store.state.customConfirm.message}}</p>
          </div>

          <div class="popup-bottom flex-cc gap-10">
              <button type="button" class="btn medium filled w-100" @click="handleCallback1">{{ store.state.customConfirm.customCallbackName1 }}</button>
              <button type="button" class="btn medium outlined w-100" @click="handleCallback2">{{ store.state.customConfirm.customCallbackName2 }} </button>
          </div>
      </div>
  </div>

</template>
<script setup>
  

import { useStore } from 'vuex';

const store = useStore();

const handleCallback1 = async () => {
    const callback = store.getters['customConfirm/getCustomCallback1']
    //함수면 콜백
    if(typeof callback === 'function' ){
      await callback()
    }
    await store.dispatch("customConfirm/close")
  }


const handleCallback2 = async () => {
    const callback2 = store.getters['customConfirm/getCustomCallback2']
    //함수면 콜백
    if(typeof callback2 === 'function' ){
        await callback2()
    }

    await store.dispatch("customConfirm/close")
}



</script>

